export let dataProps = {
    id: 0,
    category_name: '',
    default_for_appointments: false
}


// WEBPACK FOOTER //
// ./src/store/modules/taskCategory/properties.js